@if (canViewActivitySubscriptions) {
  <rt-activity-subscriptions-table
    [types]="types"
    [title]="'app.subscriptions.company_v2' | translate"
  >
    @if (hasRequisitions) {
      @if (abilities.viewRequisitions) {
        <rt-activity-subscriptions-table-row
          icon="assignment-turned-in"
          [title]="'app.subscriptions.events_group.requisitions_created_deleted' | translate"
          [activitySubscriptions]="activitySubscriptions"
          [types]="types"
          [eventsGroup]="['requisitionCreated', 'requisitionDeleted']"
          (changeEvents)="changeEvents.emit($event)"
        >
        </rt-activity-subscriptions-table-row>
      }
      @if (abilities.viewRequisitions) {
        <rt-activity-subscriptions-table-row
          icon="assignment-turned-in"
          [title]="
            'app.subscriptions.events_group.requisition_approvals_enabled_disabled' | translate
          "
          [activitySubscriptions]="activitySubscriptions"
          [types]="types"
          [eventsGroup]="['requisitionDisabled', 'requisitionEnabled']"
          (changeEvents)="changeEvents.emit($event)"
        >
        </rt-activity-subscriptions-table-row>
      }
      @if (abilities.viewRequisitions) {
        <rt-activity-subscriptions-table-row
          icon="assignment-turned-in"
          [title]="'app.subscriptions.events_group.approval_flows_fields_added_removed' | translate"
          [activitySubscriptions]="activitySubscriptions"
          [types]="types"
          [eventsGroup]="[
            'requisitionApprovalFlowCreate',
            'requisitionApprovalFlowUpdate',
            'requisitionApprovalFlowRemove',
            'requisitionFormUpdated'
          ]"
          (changeEvents)="changeEvents.emit($event)"
        >
        </rt-activity-subscriptions-table-row>
      }
    }
    @if (abilities.viewAllOffers) {
      <rt-activity-subscriptions-table-row
        icon="work"
        [title]="'app.subscriptions.events_group.job_add_v2' | translate"
        [activitySubscriptions]="activitySubscriptions"
        [types]="types"
        [eventsGroup]="['jobAdd', 'jobRemove', 'jobAutomaticallyCreatedFromRequisition']"
        (changeEvents)="changeEvents.emit($event)"
      >
      </rt-activity-subscriptions-table-row>
    }
    @if (abilities.manageRecruiters) {
      <rt-activity-subscriptions-table-row
        icon="person-outline"
        [title]="'app.subscriptions.events_group.member_add_v2' | translate"
        [activitySubscriptions]="activitySubscriptions"
        [types]="types"
        [eventsGroup]="['memberAdd', 'memberRemove']"
        (changeEvents)="changeEvents.emit($event)"
      >
      </rt-activity-subscriptions-table-row>
    }
    @if (abilities.shareCandidates) {
      <rt-activity-subscriptions-table-row
        icon="share"
        [title]="'app.subscriptions.events_group.share_container_add_v2' | translate"
        [activitySubscriptions]="activitySubscriptions"
        [types]="types"
        [eventsGroup]="['shareContainerAdd', 'shareContainerRemove']"
        (changeEvents)="changeEvents.emit($event)"
      >
      </rt-activity-subscriptions-table-row>
    }
    @if (abilities.manageCandidates) {
      <rt-activity-subscriptions-table-row
        icon="import-export"
        [title]="'app.subscriptions.events_group.import_candidates_v2' | translate"
        [activitySubscriptions]="activitySubscriptions"
        [types]="types"
        [eventsGroup]="['importFinish', 'importRevert', 'importRemove']"
        (changeEvents)="changeEvents.emit($event)"
      >
      </rt-activity-subscriptions-table-row>
    }
    @if (abilities.manageLocations) {
      <rt-activity-subscriptions-table-row
        icon="place"
        [title]="'app.subscriptions.events_group.locations_added_removed' | translate"
        [activitySubscriptions]="activitySubscriptions"
        [types]="types"
        [eventsGroup]="[
          'locationArchived',
          'locationCreated',
          'locationDeleted',
          'locationRetrieved',
          'locationUpdated'
        ]"
        [isNew]="true"
        (changeEvents)="changeEvents.emit($event)"
      >
      </rt-activity-subscriptions-table-row>
    }
    @if (abilities.manageAttributes || abilities.manageDisqualifyReasons) {
      <rt-activity-subscriptions-table-row
        icon="label"
        [title]="'app.subscriptions.events_group.tag_add_v2' | translate"
        [activitySubscriptions]="activitySubscriptions"
        [types]="types"
        [eventsGroup]="['tagAdd', 'tagRemove', 'disqualifyReasonAdd', 'disqualifyReasonRemove']"
        (changeEvents)="changeEvents.emit($event)"
      >
      </rt-activity-subscriptions-table-row>
    }
    @if (hasReferrals && abilities.manageReferrals) {
      <rt-activity-subscriptions-table-row
        icon="navbar-referrals"
        [title]="'app.subscriptions.events_group.referral_program_updated_v2' | translate"
        [activitySubscriptions]="activitySubscriptions"
        [types]="types"
        [eventsGroup]="['referralProgramUpdated']"
        (changeEvents)="changeEvents.emit($event)"
      >
      </rt-activity-subscriptions-table-row>
      <rt-activity-subscriptions-table-row
        icon="reward"
        [title]="'app.subscriptions.events_group.referral_reward_claimed_v2' | translate"
        [activitySubscriptions]="activitySubscriptions"
        [types]="types"
        [eventsGroup]="['referralRewardClaimed']"
        (changeEvents)="changeEvents.emit($event)"
      >
      </rt-activity-subscriptions-table-row>
    }
    @if (abilities.manageTexting) {
      <rt-activity-subscriptions-table-row
        icon="sms"
        [title]="'app.subscriptions.events_group.texting_enabled_disabled' | translate"
        [activitySubscriptions]="activitySubscriptions"
        [types]="types"
        [eventsGroup]="['textingEnabled', 'textingDisabled']"
        (changeEvents)="changeEvents.emit($event)"
      >
      </rt-activity-subscriptions-table-row>
      <rt-activity-subscriptions-table-row
        icon="sms"
        [title]="
          'app.subscriptions.events_group.texting_phone_number_registered_or_deleted' | translate
        "
        [activitySubscriptions]="activitySubscriptions"
        [types]="types"
        [eventsGroup]="[
          'textingPhoneNumberDeleted',
          'textingPhoneNumberRegistered',
          'textingPhoneNumberRemovedBySystem'
        ]"
        (changeEvents)="changeEvents.emit($event)"
      >
      </rt-activity-subscriptions-table-row>
    }
  </rt-activity-subscriptions-table>
}
